import { ActionReducer, combineReducers } from '@ngrx/store';
import { roleReducer } from './role/role.reducer';
import { userReducer } from './user/user.reducer';
import { ProfileState } from './profile.state';

export const profileReducer: ActionReducer<ProfileState> = combineReducers({
  role: roleReducer,
  user: userReducer,
});
